const bike = {
   info: {
      bikeType: "Bike Adulto",
      name: "",
      bikeValue: "",
      slug: "",
      timeValue: "",
      dailyValue: "",
      weekValue: "",
      monthValue: "",
      availableDates: [],
      description: "",
      rating: {},
      rateMetrics: {
         averageRating: 0,
         totalRatings: 0
      },
      status: null,
      user: null,
      options: {
         isDisableSundays: false,
         isDisableSaturdays: false,
         isDisableDaysOfTheWeek: false,
         isDisableBrazilianHolidays: false
      },
   },
   features: {
      brand: "",
      rim: "",
      frameSize: "",
      suspension: "",
      march: "",
      observation: ""
   },
   location: {
      coordinates: []
   },
   address: {
      formatted_address: "",
      name: "",
      state: "",
      city: "",
      neighborhood: ""
   },
   photos: {
      coverPhoto: "",
      photoGallery: []
   },
   _id: ""
}
export default bike;
